import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { WorkspaceV2Service } from "../services/WorkspaceV2Service";
import { AuthService } from "../services/AuthService";
export function useWorkspaceQuery(patientCountryCode = AuthService.getGeoLocation()?.country ||
    null, { keepPreviousWhileRepricing = false } = {}) {
    return useQuery({
        queryKey: ["medos", "workspace", patientCountryCode],
        queryFn: () => WorkspaceV2Service.fetchWorkspace(patientCountryCode),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
        retry: 2,
        refetchOnWindowFocus: false,
        placeholderData: keepPreviousWhileRepricing ? keepPreviousData : undefined,
    });
}
